<template>
  <button
    v-tooltip="tooltip"
    class="LmIconButton text-gray-700 leading-zero"
    :class="{
      'flex items-center': label,
      'cursor-default': disabled,
      'hover:text-gray-900': !disabled
    }"
    @click="onClick"
  >
    <span
      v-if="labelLeft"
      class="text-xs ml-0 mr-1"
      :class="highlight ? 'text-highlight' : 'text-gray-700'"
      >{{ label }}</span
    >
    <lm-icon
      v-if="svg"
      :icon="icon"
      :size="svgSize"
      :class="{
        'text-highlight': highlight && !disabled,
        'hover:text-gray-900': !disabled && !bgBlack && !svgWhite,
        'hover:text-white': !disabled && bgBlack,
        'text-gray-300': disabled,
        'text-white hover:text-gray-500': svgWhite
      }"
    />
    <i v-else :class="resolveIconType">{{ icon }}</i>
    <span
      v-if="labelRight"
      class="text-xs"
      :class="[compacted ? '-ml-2px' : 'ml-1', {'text-highlight': highlight}]"
      >{{ label }}</span
    >
    <slot />
  </button>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
export default {
  name: 'LmIconButton',
  components: {LmIcon},
  props: {
    icon: {
      type: String,
      required: true
    },
    svg: {
      type: Boolean,
      default: false
    },
    svgSize: {
      type: String,
      default: '24'
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String, // left | right
      default: 'right'
    },
    tooltip: {
      type: String,
      default: null
    },
    outline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    },
    bgBlack: {
      type: Boolean,
      default: false
    },
    compacted: {
      type: Boolean,
      default: false
    },
    svgWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelLeft() {
      return this.label && this.labelPosition === 'left'
    },
    labelRight() {
      return this.label && this.labelPosition === 'right'
    },
    resolveIconType() {
      const color = this.disabled ? 'text-gray-300' : ''
      const icon = this.outline ? 'material-icons-outlined' : 'material-icons'
      return `${icon} ${color}`
    }
  },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style>
.js-focus-visible .LmIconButton:focus:not(.focus-visible) {
  outline: none;
}
</style>
